import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.206 4.686C3.834 3.91 4.75 3.33 5.82 3.33c.953 0 1.779.453 2.37.938.594-.485 1.418-.938 2.372-.938 1.07 0 1.986.579 2.613 1.356a4.63 4.63 0 0 1 1.016 2.857c0 2.161-.317 3.778-1.594 5.689l-.021.03c-.518.688-1.172 1.183-1.947 1.345-.78.164-1.578-.034-2.33-.524a.21.21 0 0 0-.215 0c-.753.49-1.55.687-2.331.524-.775-.162-1.43-.657-1.947-1.345l-.021-.03c-1.278-1.91-1.594-3.528-1.594-5.69 0-1.045.388-2.077 1.015-2.856m1.038.837a3.3 3.3 0 0 0-.72 2.02c0 1.968.274 3.304 1.359 4.932.38.5.773.75 1.142.827.364.076.808.006 1.336-.34l.01-.006a1.54 1.54 0 0 1 1.64 0l.011.006c.528.346.97.416 1.335.34.368-.077.762-.327 1.142-.827 1.085-1.628 1.359-2.964 1.359-4.932 0-.728-.276-1.468-.72-2.02-.446-.552-1.01-.86-1.576-.86-.607 0-1.215.34-1.695.784l-.004.003a1 1 0 0 1-1.344 0l-.004-.003c-.48-.443-1.088-.784-1.695-.784-.565 0-1.13.308-1.576.86",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.421 5.64a.667.667 0 0 1-.208.92c-.269.17-.424.342-.522.535-.1.2-.167.477-.167.902a.667.667 0 0 1-1.333 0c0-.556.085-1.058.31-1.503.228-.452.573-.791 1-1.061a.667.667 0 0 1 .92.208M9.237 3.36c-.265.467-.38 1.02-.38 1.303a.667.667 0 1 1-1.333 0c0-.516.175-1.296.554-1.963.38-.669 1.061-1.37 2.113-1.37a.667.667 0 1 1 0 1.333q-.556 0-.954.697",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })